import { IMediaItem } from 'types/media'
import { PROJECT_MEDIA_TYPES } from 'consts'
import { ITextStyle } from './components/text-styles/mock-text-styles'
import { DEFAULT_LINE_HEIGHT, DEFAULT_TEXT_ALIGN } from 'consts/text'

export const generateTextMediaItem = (
  textStyle: ITextStyle,
  startTime: number,
  zIndex: number,
  canvasHeight: number
): IMediaItem => {
  const id = crypto.randomUUID()

  return {
    id,
    assetId: id,
    type: PROJECT_MEDIA_TYPES.text,
    width: 0,
    height: 0,
    rotation: 0,
    duration: 5,
    startTime,
    zIndex,
    coordinates: {
      x: 0,
      y: canvasHeight / 2
    },
    meta: {
      textData: {
        text: textStyle.text,
        fontPostScriptName: textStyle.font.postscriptName,
        fontPath: textStyle.font.path,
        fontSize: 100,
        fillColor: textStyle.fillColor,
        strokeColor: textStyle.strokeColor,
        strokeThickness: textStyle.strokeThickness,
        lineHeight: DEFAULT_LINE_HEIGHT,
        textAlign: DEFAULT_TEXT_ALIGN,
        isAutoWidth: true
      }
    }
  }
}
